import Datetimepicker from '../Datetimepicker';
import BookedHoursTooltips from './BookedHoursTooltips';

const SELECTOR = '[data-detail-view-availability]';
const WIDGET_SELECTOR = '.bootstrap-datetimepicker-widget';

class AvailabilityCalendar {
  constructor() {
    let input = document.querySelector(SELECTOR);
    if (!input) {
      return;
    }

    this.input = input;
    this.initialize();
  }

  getUnavailableDates() {
    let selectedDates = this.input.dataset.booked;
    if (!selectedDates) {
      throw new Error(
        'AvailabilityCalendar :: Missing booked attribute on the date input for aside calendar'
      );
    }

    return JSON.parse(selectedDates);
  }

  initialize() {
    new Datetimepicker($(this.input), {
      inline: true,
      keepOpen: true,
      disabledDates: this.getUnavailableDates(),
    });

    new BookedHoursTooltips();

    $(WIDGET_SELECTOR).off('click touchstart touchend');
  }
}

export default AvailabilityCalendar;



// WEBPACK FOOTER //
// ./src/javascripts/DetailView/AvailabilityCalendar.js